import ModalWrapper from "../../../common/components/modals/ModalWrapper";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { disableModals, setBovagToTrue } from "../../../app/rootReducer";
import React, { JSX, useState } from "react";
import { BovagTermsTypeEnum } from "../../../common/constants/BovagTermsTypeEnum";

function termsDocumentUrl(
    isMobile: boolean,
    mobileUrl: string,
    desktopUrl: string,
): string {
    if (isMobile && mobileUrl) {
        return mobileUrl;
    }
    return desktopUrl;
}

export const ReadBovagModal = (): JSX.Element => {
    const [isRead, setIsRead] = useState(false);
    const dispatch = useAppDispatch();
    const { registrationLink, dossier } = useAppSelector((state) => state.root);
    const [isMobile] = useState(window.innerWidth < 650);

    const handleScroll = (e: React.UIEvent<HTMLDivElement>): void => {
        const target = e.currentTarget;

        const isAtBottom =
            Math.abs(
                target.scrollHeight - target.scrollTop - target.clientHeight,
            ) < 10;

        if (isAtBottom) {
            setIsRead(true);
        }
    };

    const isBusiness =
        dossier?.bovag_terms_type === BovagTermsTypeEnum.BUSINESS;
    const termsUrl = termsDocumentUrl(
        isMobile,
        isBusiness
            ? registrationLink.terms_and_condition_business_mobile_url
            : registrationLink.terms_and_condition_private_mobile_url,
        isBusiness
            ? registrationLink.terms_and_condition_business_url
            : registrationLink.terms_and_condition_private_url,
    );

    return (
        <ModalWrapper className={"c-bovag-modal"}>
            <h1 className={"c-bovag-modal__title"}>BOVAG Voorwaarden</h1>
            <p className={"c-bovag-modal__subtitle"}>
                ABS is verplicht om je deze voorwaarden te tonen, scroll tot het
                einde om akkoord te kunnen geven.
            </p>
            <div
                className={"c-bovag-modal__image-container"}
                onScroll={handleScroll}
            >
                {termsUrl ? <img src={termsUrl} alt={"Bovag"} /> : null}
            </div>
            <p className={"c-bovag-modal__status"}>
                Status:{" "}
                <span>
                    {isRead ? "Volledig gelezen" : "Nog niet volledig gelezen"}
                </span>
            </p>
            <div className="c-form__buttons">
                <button
                    type="button"
                    className="c-form__buttons__single c-form__buttons__single___primary background-primary"
                    disabled={!isRead}
                    onClick={() => {
                        dispatch(setBovagToTrue());
                        dispatch(disableModals());
                    }}
                >
                    <span className="font-face-primary">Akkoord</span>
                </button>
            </div>
        </ModalWrapper>
    );
};
